// Lists, rows and tables — the class recipes from `BBM Context for claude/lists.md`
// (Jaylen's Lists & Rows Showroom picks, 2026-09-15). Import these instead of
// re-typing container / row / th / td classes on a page:
//
//   Ruled list (aisle 2 pick B): one bordered panel, hairline between rows,
//   hover tint, selected row = red edge + faint tint. Rows have NO border
//   or radius of their own. Status blocks (aisle 1 pick A) stay full-height
//   inside the row.
//
//   Ledger table (aisle 3 pick B): tight tracking header with no band that
//   sticks while scrolling, 40px rows, tabular right-aligned numbers, and
//   the OPEN row uses the same red edge + tint as a selected list row.

// ── Ruled list ──────────────────────────────────────────────────────────
export const listPanelCls = 'bg-white rounded-xl border border-slate-200 overflow-hidden divide-y divide-slate-100';
export const listRowCls = 'bg-white hover:bg-slate-50 transition-colors cursor-pointer';
export const listRowSelectedCls = 'bg-red-50/60 bbm-selected-edge';
// Group header pseudo-row inside the panel ("Today's walkthroughs (3)").
export const listGroupCls = 'px-4 pt-2.5 pb-1.5 bg-slate-50 text-[11px] font-bold text-slate-400 uppercase tracking-wider';
// Compact queue rows (Dashboard widgets): same recipe, tighter.
export const listRowCompactCls = 'flex items-center gap-3 px-3 py-2 bg-white hover:bg-slate-50 transition-colors cursor-pointer';

// ── Ledger table ────────────────────────────────────────────────────────
export const tableWrapCls = 'bg-white rounded-xl border border-slate-200 overflow-x-auto';
export const tableCls = 'w-full text-[13px]';
export const theadCls = '';
export const thCls = 'sticky top-0 z-[1] bg-white text-left text-[10px] font-bold uppercase tracking-wider text-slate-500 px-3 py-2 border-b border-slate-200 whitespace-nowrap';
export const thNumCls = `${thCls} text-right`;
export const trCls = 'border-t border-slate-100 hover:bg-slate-50/70 transition-colors';
export const trClickCls = `${trCls} cursor-pointer`;
// The open / selected row. Stripe sits on the first cell (box-shadow on a
// <tr> is unreliable across browsers).
export const trOpenCls = 'bg-red-50/60 bbm-open-row';
export const tdCls = 'px-3 py-2.5 align-middle';
export const tdNumCls = `${tdCls} text-right font-mono tabular-nums`;
export const tdMutedCls = `${tdCls} text-slate-500`;
// Expansion row under an open row.
export const trExpandCls = 'bg-slate-50/70';
export const tdExpandCls = 'px-4 py-3';

// Phone fallback for a table: a stacked key/value card per row.
export const kvCardCls = 'bg-white rounded-xl border border-slate-200 px-3.5 py-3 grid grid-cols-[1fr_auto] gap-x-3 gap-y-1 text-[13px]';
export const kvHeadCls = 'col-span-2 flex items-center gap-2 mb-1 min-w-0';
export const kvKeyCls = 'text-[10.5px] font-bold uppercase tracking-wider text-slate-400';
export const kvValCls = 'text-right font-mono tabular-nums text-slate-700';

export default { listPanelCls, listRowCls, listRowSelectedCls, listGroupCls, listRowCompactCls, tableWrapCls, tableCls, thCls, thNumCls, trCls, trClickCls, trOpenCls, tdCls, tdNumCls, tdMutedCls, trExpandCls, tdExpandCls, kvCardCls, kvHeadCls, kvKeyCls, kvValCls };
